/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'information': {
    width: 16,
    height: 16,
    viewBox: '0 0 29 29',
    data: '<g><g><path pid="0" d="M14.34 10.22c.52 0 .96-.18 1.32-.55.36-.37.54-.8.54-1.31 0-.52-.18-.96-.54-1.32-.36-.36-.8-.54-1.32-.54-.51 0-.94.18-1.3.54s-.54.8-.54 1.32.18.96.54 1.32.8.54 1.3.54z"/><rect pid="1" x="12.73" y="11.67" width="3.27" height="9.84"/></g><path pid="2" d="M14.5 0C6.5 0 0 6.5 0 14.5S6.5 29 14.5 29 29 22.5 29 14.5 22.5 0 14.5 0zm0 26C8.16 26 3 20.84 3 14.5S8.16 3 14.5 3 26 8.16 26 14.5 20.84 26 14.5 26z"/></g>'
  }
})
